import React, {useEffect, useRef, useState} from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import styled, {keyframes} from 'styled-components';
import LightGreenCalendar from "../../../assets/images/icon/LightGreenCalendar";
import {cloneDeep} from "lodash";
import {isEmpty, textTransform} from "../../../util";
import {CgClose} from "react-icons/cg";

interface StyledComponentProps {
    isToday:any
    isTodayOrPast:any
}

const fadeIn = keyframes`
  from {
    transform: scale(0); /* 위에서 내려오는 효과를 줍니다. */
    opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
  }

  to {
    transform: scale(1); /* 위치를 변화시켜 아래로 이동합니다. */
    opacity: 1; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
  }
`;


const CalendarWrapper = styled.div`
    width: 1000px;
    height: 100%;
    .headerDesc{
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 10px;
        color: rgba(51, 51, 51, 0.8);
        cursor: default;
    }
    h1{
        font-family: Europa-Bold;
        font-size: 20px;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 20px;
    }
`;

const CalendarHeader = styled.div`
    display: flex;
    justify-content: center;
    padding: 10px 0;
    border-radius: 6px;
    align-items: center;
    margin-bottom: 10px;
    border: 1px solid rgba(51, 51, 51, 0.3);
    width:246px;
    h2{
        cursor: default;
        width: 166px;
        font-size: 16px;
        padding-top: 3.5px;
        font-family: Europa-Bold;
        font-weight: 700;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: center;
    }
    .btns{
        display: flex;
        align-items: center;
    }
    button{
        cursor: pointer;
        border-radius: 50%;
        display: flex;
        height: 20px;
        background: none;
        border: none;
        width: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #333;
        svg{
            path{
                fill: #fff;
            }
        }
     
    }
    .next{

        svg{
            transform: rotate(180deg);
        }
    }
`;
const CalendarWrap = styled.div`
   height: calc(100% - 130px);
    overflow-y: auto;

    &::-webkit-scrollbar {
        width:8px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
;
`
const CalendarTable = styled.table`
    width: 100%;
    height: 100%!important;
    border-collapse: collapse;
    //border: 1px solid rgba(51, 51, 51, 0.4);
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    
`;
const CalendarTitle = styled.div`
    border: 1px solid rgba(51, 51, 51, 0.4);
    border-bottom: 0; 
    border-radius: 6px 6px 0 0;
    position: sticky;
  
`
const CalendarItems = styled.div`

`
const SchList = styled.div`
    cursor: pointer;
`
const SchItem = styled.div`
    font-family: Europa-Regular;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 4px;
    letter-spacing: 0em;
    text-align: center;
    transform: scale(0.87);
    opacity: 0.85;
`
const MoreBtn = styled.div`
    font-family: Europa-Bold;
    font-size: 13px;
    font-weight: 700;
    line-height: 12px;
    letter-spacing: 0em;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    width: 78px;
    text-decoration: underline;
    opacity: 0.85;
    cursor: pointer;
`
const Day = styled.div`
   height: 110px;
    
`

const CalendarTh = styled.div`
    flex: 1;
    padding: 10px;
    text-align: center;
    color: #333;
    font-weight: 500;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.9;
  
`;

const CalendarTd = styled.div<StyledComponentProps>`
    flex: 1;
    border: solid 1px rgba(51, 51, 51, 0.3);
    text-align: center;
    transition: all 0.2s;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: default;
    font-weight: 700;
    //border: 1px solid #e1e1e1;
    background: ${(props) => (!props.isTodayOrPast ? '#fff' : "rgba(51, 51, 51, 0.1)")};
    pointer-events: ${(props) => (!props.isTodayOrPast ? 'all' : "none")};
    &.dragStart{
        background: rgba(186, 225, 255, 1)!important;
        transform: scale(1.1);
        position: relative;
        z-index: 9999;
    }
    &.dragover{
        background: rgba(186, 225, 255, 1);
        transform: scale(1.1);
        position: relative;
        z-index: 9999;
    }
    &.today {
        background: #fff;
        .day{
            color:rgba(75, 133, 250, 1);
        }
        &.dragover{
            background: rgba(186, 225, 255, 1);
        }
        &.dragStart{
            background: rgba(186, 225, 255, 1)!important;
        }
    }
    
    &.selected {
        background: rgba(186, 255, 201, 0.5);
        &.dragover{
            background: rgba(186, 225, 255, 1);
            
        }
        svg {
            path {
                fill: rgba(51, 51, 51, 0.7);
            }
        }
    }

    &:hover {
        background: rgba(186, 255, 201, 0.5);

        svg {
            path {
                fill: rgba(51, 51, 51, 0.7);

            }
        }
    }

    .day {
        position: absolute;
        left: 8px;
        top: 6px;
        font-family: Europa-Bold;
        font-size: 14px;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
    }

    .calIcon {
        position: absolute;
        right: 8px;
        top: 6px;
    }

    &.custom {

        &::after {
            content: "";
            display: block;
            position: absolute;
            width: 100%;
            top: 0;
            height: 3px;
            background: rgba(186, 255, 201, 1);
        }
    }

`;


const EditMenu = styled.div`
    position: absolute;
    .close{
        position: absolute;
        right: 0px;
        top: 0px;
        padding: 5px;
        cursor: pointer;
        svg{
            width: 12px;
            color: #111;
            stroke-width: 0.5px;
        }
    }
    animation: ${fadeIn} 0.2s ease-in-out; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    height: 70%;
    transform-origin: left top;
    border-radius: 5px;
    background: #fff;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 10px 0px;
    box-shadow: 0 0.1rem 1rem rgba(0, 0, 0, 0.16);
    
    span {
        cursor: pointer;
        font-size: 12px;
        font-weight: 500;
        padding: 5px 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:nth-child(1) {
            margin-bottom: 5px;
        }
    }
`
const CalendarInputWrapper = styled.div`
    display: flex;
    margin-bottom: 20px;
`;

const CalendarInput = styled.input`
    flex: 1;
    padding: 8px;
    margin-right: 10px;
`;

const CalendarButton = styled.button`
    background-color: #3498db;
    color: #ffffff;
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
`;

const Calendar = (props) => {
    const [currentDate, setCurrentDate] = useState(dayjs());
    const [inputDate, setInputDate] = useState('');
    const [height, setHeight] = useState(50)
    const sizeRef = useRef(null)
    const [selectedDate, setSelectedDate] = useState(null);
    const [ani, setAni] = useState("");
    const [bubble, setBubble] = useState(false);
    const [dragStartDate, setDragStartDate] = useState(null);
    const [dragOverDate, setDragOverDate] = useState(null)
    const [dragEndDate, setDragEndDate] = useState(null);
    const [dragState, setDragState] = useState(false);

    useEffect(() => {
        if(sizeRef.current){
            setHeight(sizeRef.current.clientWidth)
        }
    }, [sizeRef.current]);
    const handleInputChange = (e) => {
        setInputDate(e.target.value);
    };

    const handleDateSubmit = () => {
        if (dayjs(inputDate).isValid()) {
            setCurrentDate(dayjs(inputDate));
        } else {
            alert('올바른 날짜 형식을 입력하세요.');
        }
    };

    const returnSch = (day:any) => {
        const weekItem = props.weekItem;
        const c = cloneDeep(weekItem)
        const findItem = c.find(item => {
            return item.dayOfWeek === day
        });
        const arr = findItem?.times?.slice(0,2)?.map(item => {
            return(
                <SchList style={{
                    cursor:"default"
                }}>
                    <SchItem>
                        {item?.startTime} - {item?.endTime}
                    </SchItem>
                </SchList>
            )
        })
        const data = {
            arr:arr,
            length:findItem?.times?.length
        }
        return data;
    }

    const returnCustomSch = (date) => {

        const customItem = props.customData;
        const c = cloneDeep(customItem);
        const findItem = c.find(item => item?.date === date);
        const arr = findItem?.times?.slice(0,2)?.map(item => {
            return(
                <SchList>
                    <SchItem
                        onClick={()=>{
                            // props.onClickPopupDate(date)
                            // props.onClickMore(date)
                        }}
                    >
                        {item?.startTime} - {item?.endTime}
                    </SchItem>
                </SchList>
            )
        })
        return {
            arr :arr,
            length: findItem?.times.length
        };
    };
    const handleDragStart = (e, day) => {
        setBubble(false)
        setDragStartDate(day)
    };
    const handleDragOver = (e,day) => {
        e.preventDefault(); // 드롭을 허용하기 위해 기본 이벤트 방지
        setDragOverDate(day)
    };
    const handleDrop = (e, targetDay) => {
        console.log("@targetDay",targetDay);
        console.log("@dragStartDate",dragStartDate);
        e.preventDefault();
        const customItem = props.customData;
        const c = cloneDeep(customItem);
        const findStartItem = c.find(item => item?.date === dragStartDate);
        const findItem = c?.find(item => item?.date === targetDay);
        console.log("@findItem",findItem);
        setDragOverDate(null)
        setDragStartDate(null)
        if(!isEmpty(findItem) && !isEmpty(findStartItem)){
            findItem.date = dragStartDate;
            findStartItem.date = targetDay;
            props.setCustomData(c)
            setSelectedDate(dayjs(targetDay))
        }
        if(isEmpty(findStartItem) && !isEmpty(findItem)){
            setSelectedDate(dayjs(dragStartDate))
            findItem.date = dragStartDate;
            props.setCustomData(c)
        }
        if(!isEmpty(findStartItem)){
            findStartItem.date = targetDay;
            props.setCustomData(c)
            setSelectedDate(dayjs(targetDay))
        }
        if(isEmpty(findItem) && isEmpty(findStartItem)){
            setDragStartDate(null)
            setDragOverDate(null)
            return;
        }
        console.log("@drop",findItem);
        console.log("@findStartItem",findStartItem);
    };
    useEffect(() => {
        console.log("@select", selectedDate);
    }, [selectedDate]);
    
    console.log("@props",props);
    const renderCalendar = () => {
        const weekdays = Array.from({ length: 7 }, (_, i) => dayjs().startOf('week').add(i, 'day').format('ddd'));

        return (
            <CalendarWrapper>
                {/*<CalendarInputWrapper>*/}
                {/*    <CalendarInput type="text" value={inputDate} onChange={handleInputChange} placeholder="YYYY-MM-DD" />*/}
                {/*    <CalendarButton onClick={handleDateSubmit}>날짜 변경</CalendarButton>*/}
                {/*</CalendarInputWrapper>*/}
                <CalendarHeader>
                    <div className="btns">
                        <button onClick={goToPreviousMonth}>
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M1.81089 5.00075L5.77929 1.22102C6.07357 0.941048 6.07357 0.488922 5.77929 0.209033C5.63933 0.0752656 5.44843 -2.38159e-07 5.24932 -2.29455e-07C5.05021 -2.20752e-07 4.85931 0.0752657 4.71936 0.209033L0.22099 4.494C-0.0736636 4.77372 -0.0736636 5.2262 0.22099 5.50591L4.71917 9.79097C4.85931 9.92473 5.05021 10 5.24932 10C5.44843 10 5.63933 9.92473 5.77948 9.79097C6.07357 9.5109 6.07338 9.05886 5.7791 8.77889L1.81089 5.00075Z"
                                      fill="#333333"/>
                            </svg>
                        </button>
                        <h2>{currentDate.format('MMMM, YYYY')}</h2>
                        <button onClick={goToNextMonth} className={"next"}>
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M1.81089 5.00075L5.77929 1.22102C6.07357 0.941048 6.07357 0.488922 5.77929 0.209033C5.63933 0.0752656 5.44843 -2.38159e-07 5.24932 -2.29455e-07C5.05021 -2.20752e-07 4.85931 0.0752657 4.71936 0.209033L0.22099 4.494C-0.0736636 4.77372 -0.0736636 5.2262 0.22099 5.50591L4.71917 9.79097C4.85931 9.92473 5.05021 10 5.24932 10C5.44843 10 5.63933 9.92473 5.77948 9.79097C6.07357 9.5109 6.07338 9.05886 5.7791 8.77889L1.81089 5.00075Z"
                                      fill="#333333"/>
                            </svg>
                        </button>
                    </div>
                </CalendarHeader>
                <p className={"headerDesc"}>Set your weekly hours</p>

                    <CalendarTable
                        className={`calendarTable ${ani === "prev" ? "prev" : ""} ${ani === "next" ? "next" : ""} ${ani === "on" ? "on" : ""}`}>
                        <CalendarTitle style={{display: 'flex'}}>
                            {weekdays.map((day, index) => (
                                <CalendarTh key={index}>{day}</CalendarTh>
                            ))}
                        </CalendarTitle>
                        <CalendarWrap>
                        <CalendarItems>

                            {generateCalendarMatrix().map((week, weekIndex) => (
                                <Day key={weekIndex} style={{display: 'flex'}}>
                                    {week.map((day, dayIndex) => {
                                            return (
                                                <React.Fragment>
                                                    <CalendarTd
                                                        draggable="true"
                                                        onDragEnd={(e) => {
                                                            console.log("@exit", e);
                                                            setDragOverDate(null)
                                                            setDragStartDate(null)
                                                        }}
                                                        onDragStart={(e) => handleDragStart(e, String(day.format("YYYY-MM-DD")))}
                                                        onDragOver={(e) => {
                                                            handleDragOver(e, day)
                                                        }}
                                                        onDrop={(e) => handleDrop(e, day.format("YYYY-MM-DD"))}

                                                        ref={sizeRef}
                                                        onClick={() => {
                                                            setSelectedDate(day)
                                                            console.log("@test", isEmpty(0));
                                                            setBubble(true);
                                                            if (returnSch(day.format("dddd").toLocaleUpperCase()).length === 0 &&
                                                                isEmpty(returnCustomSch(day.format("YYYY-MM-DD"))?.length)) {
                                                                props.onClickMore(String(day.format("YYYY-MM-DD")))
                                                            }
                                                            if (
                                                                (returnSch(day.format("dddd").toLocaleUpperCase()).length === 0) &&
                                                                !isEmpty(returnCustomSch(day.format("YYYY-MM-DD"))?.length)
                                                            ) {
                                                                props.onClickMore(String(day.format("YYYY-MM-DD")))
                                                            }
                                                        }}
                                                        className={`${day && day?.isSame(dayjs(), 'day') ? "today" : ""} 
                                                    ${returnCustomSch(day.format("YYYY-MM-DD"))?.length > 0 ? "custom" : ""}
                                                    ${day && selectedDate?.isSame(day, 'day') ? "selected" : ""}
                                                    ${day && dragOverDate?.isSame(day, 'day') ? "dragover" : ""} 
                                                    ${day && dayjs(dragStartDate)?.isSame(day, 'day') ? "dragStart" : ""} 
                                                    `
                                                        }
                                                        isToday={day && day?.isSame(dayjs(), 'day')}
                                                        isTodayOrPast={day && day.isBefore(dayjs(), 'day')}
                                                        key={dayIndex}>
                                                        {
                                                            selectedDate?.isSame(day, 'day') &&
                                                            (returnSch(day.format("dddd").toLocaleUpperCase()).length > 0) && bubble &&
                                                            <EditMenu
                                                                onClick={(e) => {
                                                                    e.stopPropagation()
                                                                }}
                                                            >
                                                    <span
                                                        onClick={() => {
                                                            props.onClickMore(String(day.format("YYYY-MM-DD")))
                                                        }}
                                                    >Edit Date</span>
                                                                <span
                                                                    onClick={() => {
                                                                        setSelectedDate(day)
                                                                        props.onClickWeekPopup()
                                                                    }}
                                                                >Edit All {textTransform().capitalizeFirstLetter(String(day.format("dddd").toLocaleLowerCase()))}</span>
                                                                <div className="close"
                                                                     onClick={() => {
                                                                         setBubble(false)
                                                                     }}
                                                                >
                                                                    <CgClose/>
                                                                </div>
                                                            </EditMenu>
                                                        }
                                                        <span className={"day"}>
                                               {day ? day.format('D') : ''}
                                        </span>
                                                        {returnCustomSch(day.format("YYYY-MM-DD"))?.arr}

                                                        {
                                                            returnCustomSch(day.format("YYYY-MM-DD"))?.length > 2
                                                            &&
                                                            <MoreBtn
                                                                onClick={() => {
                                                                    // props.onClickMore(String(day.format("YYYY-MM-DD")))
                                                                }}
                                                            >
                                                                more
                                                            </MoreBtn>
                                                        }
                                                        {
                                                            returnCustomSch(day.format("YYYY-MM-DD"))?.length > 0
                                                                ?
                                                                <div className="calIcon">
                                                                    <LightGreenCalendar/>
                                                                </div>
                                                                :
                                                                !(day && day.isBefore(dayjs(), 'day')) &&
                                                                returnSch(day.format("dddd").toLocaleUpperCase())?.arr
                                                        }
                                                    </CalendarTd>

                                                </React.Fragment>
                                            )
                                        }
                                    )}
                                </Day>
                            ))}
                        </CalendarItems>
                        </CalendarWrap>
                    </CalendarTable>


            </CalendarWrapper>
        );
    };

    const generateCalendarMatrix = () => {
        const firstDayOfMonth = currentDate.startOf('month').startOf('week');
        const lastDayOfMonth = currentDate.endOf('month').endOf('week');

        const calendarMatrix = [];
        let currentDay = firstDayOfMonth.clone();

        while (currentDay.isBefore(lastDayOfMonth) || currentDay?.isSame(lastDayOfMonth, 'day')) {
            const week = [];
            for (let i = 0; i < 7; i++) {
                week.push(currentDay.clone());
                currentDay = currentDay.add(1, 'day');
            }
            calendarMatrix.push(week);
        }

        return calendarMatrix;
    };

    const goToPreviousMonth = () => {
        setCurrentDate(currentDate.subtract(1, 'month'));

    };

    const goToNextMonth = () => {
        setCurrentDate(currentDate.add(1, 'month'));
    };

    return (
        <Container className={"customCalendar"}>
            {renderCalendar()}
        </Container>
    );
};

const Container = styled.div`
    height: 100%;
`
export default Calendar
